// src/i18n/en/views/iframes.js
export const iframes = {
  pricing: {
    title: "Calcolatore dei prezzi",
    description:
      "Configura i prezzi base e i supplementi per unità in base al piano; nelle fatture l'imposta viene mostrata come voce separata.",
    src: "https://player.vimeo.com/video/00000001",
    ariaLabel: "Video: Calcolatore dei prezzi (EN)",
  },
  connectBooking: {
    title: "Collega Booking.com",
    description:
      "Guida passo passo per collegare la tua struttura a Booking.com tramite il Channel Manager.",
    src: "https://player.vimeo.com/video/00000002",
    ariaLabel: "Video: Collega Booking.com (EN)",
  },
  connectAirbnb: {
    title: "Collega Airbnb (tramite Channex)",
    description:
      "Attiva la connessione Airbnb dal tuo PMS utilizzando Channex e sincronizza disponibilità e tariffe.",
    src: "https://player.vimeo.com/video/00000003",
    ariaLabel: "Video: Collega Airbnb (EN)",
  },
  channexCertification: {
    title: "Certificazione Channex · PMS",
    description:
      "Requisiti e test per completare la certificazione PMS con Channex (sincronizzazione completa, prezzi, restrizioni).",
    src: "https://player.vimeo.com/video/00000004",
    ariaLabel: "Video: Certificazione Channex (EN)",
  },
  hotelCalendar: {
    title: "Calendario hotel (multi-camera)",
    description:
      "Gestisci le prenotazioni per tipologia di camera e singola unità; evita gli overbooking con una vista strutturata.",
    src: "https://player.vimeo.com/video/00000005",
    ariaLabel: "Video: Calendario hotel (EN)",
  },
  apartmentCalendar: {
    title: "Calendario appartamenti",
    description:
      "Blocchi, prezzi giornalieri e soggiorni in un calendario per ogni struttura.",
    src: "https://player.vimeo.com/video/00000006",
    ariaLabel: "Video: Calendario appartamenti (EN)",
  },
  guestCheckin: {
    title: "Check-in via WhatsApp",
    description:
      "Gli ospiti scansionano il documento, superano la verifica dell'identità e firmano digitalmente dal telefono.",
    src: "https://player.vimeo.com/video/00000007",
    ariaLabel: "Video: Check-in via WhatsApp (EN)",
  },
  identityVerification: {
    title: "Verifica dell'identità e firma elettronica",
    description:
      "Controllo del selfie, lettura MRZ/PDF417 e firma elettronica sicura per la conformità.",
    src: "https://player.vimeo.com/video/00000008",
    ariaLabel: "Video: Verifica dell'identità (EN)",
  },
  smartLocks: {
    title: "Serrature intelligenti",
    description:
      "Invia codici di accesso automatici, senza chiavi né attese. Supporta i codici dinamici.",
    src: "https://player.vimeo.com/video/00000009",
    ariaLabel: "Video: Serrature intelligenti (EN)",
  },
  reviewsAutomation: {
    title: "Automazione delle recensioni",
    description:
      "Programma i promemoria per le recensioni e migliora la reputazione della tua struttura.",
    src: "https://player.vimeo.com/video/00000010",
    ariaLabel: "Video: Automazione delle recensioni (EN)",
  },
};
